import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';

import { InteractionRequiredAuthError, InteractionStatus } from "@azure/msal-browser";
import { useAccount, useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";

export const ApiDomains = {
    //Collaudo
    GiustiziaMap: window._env_.GM_API_URL,
    //DEV
    // GiustiziaMap: "https://localhost:5045/Api",
}

export const HttpMethods = {
    GET: 'GET',
    POST: 'POST',
    DELETE: 'DELETE',
    PUT: 'PUT',
}

const compileRoute = (route, params) => {
    if (params) {
        const paramsPropNames = Object.getOwnPropertyNames(params);
        if (paramsPropNames && paramsPropNames.length > 0) {
            route = `${route}?`
            paramsPropNames
                .filter(paramPropName => params[paramPropName] !== null && params[paramPropName] !== undefined)
                .forEach(paramPropName => {
                    const routeParamPropName = `{${paramPropName}}`;
                    const startIndexOfParamPropName = route.toLowerCase().indexOf(routeParamPropName.toLocaleLowerCase());
                    if (startIndexOfParamPropName == -1)
                        route = `${route}${paramPropName}=${params[paramPropName]}&`;
                    else
                        route = `${route.substr(0, startIndexOfParamPropName)}${params[paramPropName]}${route.substr(startIndexOfParamPropName + routeParamPropName.length, route.length)}`;
                });
            route = route.substr(0, route.length - 1);
        }
    }
    return route;
}

export const ApiRoutes = {
    Competenza: {
        GetCompetenza: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Competenze/{competenzaId}`, params),
        GetCompetenze: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Competenze`, params),
        AddCompetenza: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Competenze`, params),
        UpdateCompetenza: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Competenze/{competenzaId}`, params),
        DeleteCompetenza: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Competenze/{competenzaId}`, params),
        AssignCompetenze: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Competenze/{competenzaId}/Uffici/{ufficioId}/assegna`, params),
    },
    Comune: {
        UpdateComuni: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Comuni`, params),
        AutoImportComuni: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Comuni/AutoImporta`, params),
        ImportComuni: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Comuni/Importa`, params),
        AutoImportCAP: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Comuni/AutoImportaCAP`, params),
        ImportCAP: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Comuni/ImportaCAP`, params),
        GetComuni: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Comuni`, params),
        GetComune: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Comuni/{comuneId}`, params),
        AddComune: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Comuni`, params),
        UpdateComune: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Comuni/{comuneId}`, params),
        DeleteComune: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Comuni/{comuneId}`, params),
        GetCompetenze: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Comuni/{comuneId}/Competenze`, params),
        AddCompetenza: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Comuni/{comuneId}/Competenze`, params),
        GetCompetenza: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Comuni/{comuneId}/Competenze/{competenzaId}`, params),
        UpdateCompetenza: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Comuni/{comuneId}/Competenze/{competenzaId}`, params),
        DeleteCompetenza: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Comuni/{comuneId}/Competenze/{competenzaId}`, params),
        GetEccezioni: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Comuni/{comuneId}/Competenze/{competenzaId}/Eccezioni`, params),
        AddEccezione: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Comuni/{comuneId}/Competenze/{competenzaId}/Eccezioni`, params),
        GetEccezione: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Comuni/{comuneId}/Competenze/{competenzaId}/Eccezioni/{eccezioneId}`, params),
        UpdateEccezione: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Comuni/{comuneId}/Competenze/{competenzaId}/Eccezioni/{eccezioneId}`, params),
        DeleteEccezione: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Comuni/{comuneId}/Competenze/{competenzaId}/Eccezioni/{eccezioneId}`, params),
        GetUffici: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Comuni/{comuneId}/Uffici`, params),
        GetUfficiXML: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Comuni/{comuneId}/Uffici/XML`, params),
        GetAltriUffici: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Comuni/{comuneId}/AltriUffici`, params),
        GetStorici: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Comuni/{comuneId}/Competenze/{competenzaId}/storici`, params),
        GetStorico: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Comuni/{comuneId}/Competenze/{competenzaId}/storici/{storicoId}`, params),
        ImportCompetenze: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Comuni/{comuneId}/Competenze/importa/{importComuneId}`, params)
    },
    Provincia: {
        GetProvincia: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Province/{provinciaId}`, params),
        GetProvince: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Province`, params),
        AddProvincia: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Province`, params),
        UpdateProvincia: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Province/{provinciaId}`, params),
        DeleteProvincia: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Province/{provinciaId}`, params),
    },
    Regione: {
        GetRegione: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Regioni/{regioneId}`, params),
        GetRegioni: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Regioni`, params),
        AddRegione: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Regioni`, params),
        UpdateRegione: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Regioni/{regioneId}`, params),
        DeleteRegione: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Regioni/{regioneId}`, params),
    },
    TipoContatto: {
        GetTipoContatto: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/TipiContatti/{tipoContattoId}`, params),
        GetTipiContatti: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/TipiContatti`, params),
        AddTipoContatto: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/TipiContatti`, params),
        UpdateTipoContatto: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/TipiContatti/{tipoContattoId}`, params),
        DeleteTipoContatto: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/TipiContatti/{tipoContattoId}`, params),
    },
    TipoUfficio: {
        GetTipoUfficio: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/TipiUffici/{tipoUfficioId}`, params),
        GetTipiUffici: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/TipiUffici`, params),
        AddTipoUfficio: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/TipiUffici`, params),
        UpdateTipoUfficio: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/TipiUffici/{tipoUfficioId}`, params),
        DeleteTipoUfficio: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/TipiUffici/{tipoUfficioId}`, params),
    },
    Ufficio: {
        GetUffici: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Uffici`, params),
        GetUfficiXML: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Uffici/XML`, params),
        AddUfficio: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Uffici`, params),
        GetUfficio: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Uffici/{ufficioId}`, params),
        UpdateUfficio: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Uffici/{ufficioId}`, params),
        DeleteUfficio: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Uffici/{ufficioId}`, params),
        GetContatti: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Uffici/{ufficioId}/contatti`, params),
        AddContatto: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Uffici/{ufficioId}/contatti`, params),
        GetContatto: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Uffici/{ufficioId}/contatti/{contattoId}`, params),
        UpdateContatto: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Uffici/{ufficioId}/contatti/{contattoId}`, params),
        DeleteContatto: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Uffici/{ufficioId}/contatti/{contattoId}`, params),
        UpdateContatti: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Uffici/{ufficioId}/contatti`, params),
        GetStorici: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Uffici/{ufficioId}/storici`, params),
        GetStorico: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Uffici/{ufficioId}/storici/{storicoId}`, params),
        GetComuni: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Uffici/{ufficioId}/Comuni`, params),
        LockUfficio: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Uffici/{ufficioId}/Lock`, params),
        UnlockUfficio: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Uffici/{ufficioId}/Unlock`, params),
    },
    Utente: {
        GetMe: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Utenti/Me`, params),
        GetUtenti: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Utenti`, params),
        AddUtente: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Utenti`, params),
        GetUtente: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Utenti/{utenteId}`, params),
        UpdateUtente: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Utenti/{utenteId}`, params),
        DeleteUtente: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Utenti/{utenteId}`, params),
    },
    Impostazione: {
        GetImpostazione: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Impostazioni`, params),
        UpdateImpostazione: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Impostazioni`, params)
    },
    Ruolo: {
        GetRuoli: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Ruoli`, params),
    },
    File: {
        AddFile: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/File`, params),
        GetFile: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/File/{fileId}`, params),
        GetFiles: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/File`, params),
    }
}

export const FetchContext = React.createContext(null);

const { Provider } = FetchContext;
export const FetchProvider = ({ ...props }) => {

    const { instance, inProgress, accounts } = useMsal();
    const account = useAccount(accounts[0] || {});
    const [token, setToken] = useState("");
    const [user, setUser] = useState("");

    useEffect(() => {
        if (inProgress === InteractionStatus.None) {
            const accessTokenRequest = {
                scopes: loginRequest.scopes,
                account: accounts[0],
            };
            instance
                .acquireTokenSilent(accessTokenRequest)
                .then((accessTokenResponse) => {
                    let accessToken = accessTokenResponse.accessToken;
                    setToken(accessToken);
                })
                .catch((error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance
                            .acquireTokenPopup(accessTokenRequest)
                            .then(function (accessTokenResponse) {
                                let accessToken = accessTokenResponse.accessToken;
                                setToken(accessToken);
                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    }
                    console.log(error);
                });
        }
    }, [account]);

    useEffect(() => {
        if (token) {
            getMeAsync();
        } else {
            const accessTokenRequest = {
                scopes: loginRequest.scopes,
                account: accounts[0],
            };
            instance
                .acquireTokenSilent(accessTokenRequest)
                .then((accessTokenResponse) => {
                    let accessToken = accessTokenResponse.accessToken;
                    setToken(accessToken);
                })
                .catch((error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance
                            .acquireTokenPopup(accessTokenRequest)
                            .then(function (accessTokenResponse) {
                                let accessToken = accessTokenResponse.accessToken;
                                setToken(accessToken);
                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    }
                    console.log(error);
                });
        }
    }, [token]);

    const { enqueueSnackbar } = useSnackbar();

    const snackOptions = { variant: "error", autoHideDuration: 5000 };

    const createError = (code, message) => {
        const error = new Error(message);
        error.code = code;
        return error;
    }

    // source: https://dev.to/ycmjason/javascript-fetch-retry-upon-failure-3p6g
    const fetchRetry = (retries, api, cfg) => {
        return fetch(api, cfg).catch(function (error) {
            if (retries === 1) throw error;
            return fetchRetry(api, cfg, retries - 1);
        });
    }

    const fetchOk = (api, cfg) => {

        var isIE = !!window.MSInputMethodContext && !!document.documentMode;

        const headers = {};
        if (cfg.body && (typeof cfg.body === "string" || cfg.body instanceof String)) {
            headers["Content-Type"] = "application/json"
        }

        if (cfg.headers) {
            for (var pair of cfg.headers.entries()) {
                headers[pair[0]] = pair[1];
            }
        }

        cfg = {
            ...cfg,
            cache: 'no-cache',
            headers: new Headers({
                ...headers,
                "Cache-Control": "no-cache",
                "Pragma": "no-cache",
                "Expires": "0",
                "XLanguage": cfg.cultureName || "default"
            })
        };

        return fetch(api, cfg)
            .then(r => {
                if (r.ok) {
                    return r;
                } else {
                    switch (r.status) {
                        // Bad Request
                        case 400:
                            return r.json()
                                .then(data => {
                                    if (data.errors) {
                                        const errorKeys = Object.keys(data.errors);
                                        if (cfg.collectErrorDetails) {
                                            const error = new Error("Invalid data supplied");
                                            error.details = errorKeys.map(x => ({
                                                errorId: x,
                                                message: data.errors[x][0]
                                            }));
                                            error.code = r.status;
                                            return Promise.reject(error);
                                        } else {
                                            errorKeys.forEach(errorKey => {
                                                const error = data.errors[errorKey][0];
                                                enqueueSnackbar(error, snackOptions);
                                            });
                                        }
                                    }
                                    return Promise.reject(createError(r.status, "Invalid data supplied"));
                                });
                        // Unauthorized
                        case 401:
                            return Promise.reject(createError(r.status, "User is not authorized"));
                        // Forbidden
                        case 403:
                            return Promise.reject(createError(r.status, "User is not allowed"));
                        // Not Found
                        case 404:
                            return Promise.reject(createError(r.status, "Resource not found"));
                        // Server Error
                        case 500:
                            return r.json()
                                .then(data => {
                                    let message = null;
                                    if (data.message) message = data.message;
                                    else message = "An internal error occured";
                                    return Promise.reject(createError(r.status, message));
                                });
                        // Not handled
                        default:
                            return Promise.reject(createError(r.status, "Something went bad"));
                    }
                }
            })
            .catch(error => {
                enqueueSnackbar(error.message, snackOptions);
                return Promise.reject(error);
            });
    }

    const fetchAuthorized = (api, cfg) => {
        return fetchOk(api, {
            ...cfg,
            headers: new Headers({
                "Authorization": `Bearer ${token}`
            })
        })
    }

    // Used for debug purpose
    const delay = (duration) => {
        return new Promise((resolve) => setTimeout(resolve, duration));
    }

    const [isLoadingMe, setIsLoadingMe] = useState(false);
    const getMeAsync = async () => {
        try {
            setIsLoadingMe(true);
            const r = await fetchAuthorized(ApiRoutes.Utente.GetMe(), {
                method: HttpMethods.GET
            });
            const result = await r.json();
            setUser(result);
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingMe(false);
        }
    }

    return (
        <Provider value={{
            fetchRetry,
            fetchOk,
            fetchAuthorized,

            getMeAsync,
            isLoadingMe,
            user,
        }}>
            {props.children}
        </Provider>
    );
}